import { render } from "./LeadsListProcessing.vue?vue&type=template&id=47341339"
import script from "./LeadsListProcessing.vue?vue&type=script&lang=js"
export * from "./LeadsListProcessing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__